(function(){
    function initialiseHelp()
    {
        document.getElementById('header-primary').onclick = function(event) {

            const helpMenu = document.getElementById('help_pane');

            if (event.target.classList.contains('help')) {
                event.preventDefault();
                helpMenu.classList.toggle('is-open');
            }
        };
    }

    setTimeout(initialiseHelp, 1000);
})();
